"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.prompt-assist.disabled': 'La funzione assistente prompt non è disponibile nel tuo piano attuale.',
};
